// @ts-ignore
import BotoComponent from 'components/corporatiu/Boto';
const Boto: any = BotoComponent;
import styles from './destacatcorba.module.scss';
// @ts-ignore
import Imatge from 'components/corporatiu/Imatge';
import clsx from 'clsx';
import { DestacatCorbaProps } from './DestacatCorba.types';

const DestacatCorba = (props: Readonly<DestacatCorbaProps>) => {
    const { titol, text, textBoto, temaBoto, imgFons, estil, corbaEsquerra = false, link } = props;

    const stylesContentModul = clsx(styles.contentModul, estil ? styles[estil] : undefined, corbaEsquerra && styles.corbaEsquerra);

    return (
        <div className={stylesContentModul}>
            <div className={styles.background}>
                <div className={styles.wrapper}>
                    <div className={styles.content}>
                        <h2 className={styles.titol}>{titol}</h2>
                        <p className={styles.text}>{text}</p>
                        <Boto className={styles.boto} text={textBoto} tema={temaBoto} link={link} />
                    </div>
                </div>
                <div className={styles.imatge}>
                    <Imatge src={imgFons} layout='fill' objectFit='cover' alt='' />
                </div>
            </div>
        </div>
    );
};

export default DestacatCorba;
